import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import PromoSection from './components/PromoSection';
import ArticleGrid from './components/ArticleGrid';
import FAQSection from './components/FAQSection';

const Home = () => {
  useEffect(() => {
    document.title = 'JoyaGoo Coupon Code 2026 – Get Up to 50% Off | joyagoocoupon.net';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) {
      desc.setAttribute('content', 'Find the latest joyagoo coupon codes, promo codes, and exclusive deals for 2026. Save up to 50% on shoes, hoodies, jerseys and more. Verified joyagoo discount codes updated daily at joyagoocoupon.net.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <PromoSection />
        <ArticleGrid />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
